var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import typography from "@/styles/Typography";
import palette from "@/styles/palette";
export default {
    styleOverrides: {
        root: {
            background: palette.background.paper,
            borderRadius: 5,
            "&.Mui-focused fieldset": {
                borderColor: palette.primary.light,
            },
            "&.Mui-disabled fieldset": {
                borderColor: 'transparent !important',
            },
            "'&:hover $notchedOutline'": {
                borderColor: palette.primary.light
            }
        },
        multiline: {},
        input: __assign(__assign({}, (typography.body1)), { background: palette.background.paper, borderColor: 'transparent', borderRadius: 5, "&::placeholder": __assign(__assign({}, (typography.body1)), { opacity: 0.5 }) }),
        notchedOutline: {
            borderColor: 'transparent',
        }
    }
};
